import Notification from '../notification/notification-es';

const popup = Notification({
    position: 'top-right',
    duration: 5000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

function handleNotification() {
    console.log('handleNotification', window.__APP_NOTIFICATION__);

    const message = window.__APP_NOTIFICATION__ || null;
    if (!message) return;
    console.log('1')

    popup.info({ message });

    // сразу чистим глобалку
    try {
        delete window.__APP_NOTIFICATION__;
    } catch (e) {
        window.__APP_NOTIFICATION__ = null;
    }
}

document.addEventListener('DOMContentLoaded', function handler() {
    document.removeEventListener('DOMContentLoaded', handler);
    handleNotification();
});
